"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isParentBindingConstraints = isParentBindingConstraints;
function isParentBindingConstraints(condition) {
    return (constraints) => {
        const ancestorMetadata = constraints.getAncestor();
        return ancestorMetadata !== undefined && condition(ancestorMetadata);
    };
}
//# sourceMappingURL=isParentBindingConstraints.js.map